import './App.css';
import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import LandingPage from './pages/LandingPage/LandingPage';


function AppInitializer() {

  return (
    <>
      <Routes>
        <Route path="*" element={<LandingPage/>}/>
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppInitializer/>
    </Router>
  );
}

export default App;
